/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_MinifiedInputs */

const en_stats_minified = /** @type {(inputs: Stats_MinifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minified`)
};

const ko_stats_minified = /** @type {(inputs: Stats_MinifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축 후`)
};

const ja_stats_minified = /** @type {(inputs: Stats_MinifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮後`)
};

/**
* | output |
* | --- |
* | "Minified" |
*
* @param {Stats_MinifiedInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const stats_minified = /** @type {((inputs?: Stats_MinifiedInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_MinifiedInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stats_minified(inputs)
	if (locale === "ko") return ko_stats_minified(inputs)
	return ja_stats_minified(inputs)
});